import elementoVisivel from '../dom';

const EDITAR = '[data-tour="recursos-editar-manifestacao"]';
const EXCLUIR = '[data-tour="recursos-excluir-manifestacao"]';

/**
 * Hints pontuais nos botões editar/excluir — após o tour `recursos-editar-excluir`,
 * quando as ações estiverem visíveis (recursos e/ou contrarrazões).
 */
export default {
  id: 'recursos-editar-excluir-hints',
  kind: 'hint',
  version: 1,
  label: 'Dicas de editar e excluir',
  contexts: ['auction.recursos'],
  scopes: ['acoes-editar-excluir'],
  priority: 60,
  help: false,
  requires: ['recursos-editar-excluir'],
  canQueue(ctx = {}) {
    return Boolean(ctx.logged && ctx.acoesVisiveis);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.acoesVisiveis) return false;
    return Boolean(elementoVisivel(EDITAR) || elementoVisivel(EXCLUIR));
  },
  hints() {
    const items = [];

    if (elementoVisivel(EDITAR)) {
      items.push({
        id: 'editar',
        element: EDITAR,
        beacon: { side: 'top', align: 'end' },
        popover: {
          title: 'Editar',
          description:
            'Enquanto a janela estiver aberta, use este botão para corrigir o texto e os anexos da manifestação.',
          side: 'bottom',
          align: 'end',
          buttonText: 'Entendi',
        },
      });
    }

    if (elementoVisivel(EXCLUIR)) {
      items.push({
        id: 'excluir',
        element: EXCLUIR,
        beacon: { side: 'top', align: 'end' },
        popover: {
          title: 'Excluir',
          description:
            'Remove a manifestação com justificativa. Em recursos, a exclusão impede um novo envio (preclusão consumativa).',
          side: 'bottom',
          align: 'end',
          buttonText: 'Entendi',
        },
      });
    }

    return items;
  },
};
